export default "__VITE_ASSET__Dyz8LobA__"